const ACTUAL_OVER_ACTUAL = "6ed392ab-2f95-4186-a1ab-e3e4019051ed";
const ACTUAL_OVER_365 = "27c630c3-766f-11e9-87b9-0242ac120002";
const ACTUAL_OVER_360 = "fb692b8f-766e-11e9-87b9-0242ac120002";
const THIRTY_OVER_360 = "41a7e0bb-fd1e-42b4-8c50-c5e44dc81372";

export const daycountList = [
  { name: "Act/360", value: ACTUAL_OVER_360 },
  { name: "Act/365", value: ACTUAL_OVER_365 },
  { name: "30/360", value: THIRTY_OVER_360 },
  { name: "Act/Act", value: ACTUAL_OVER_ACTUAL }
];

export default {
  ACTUAL_OVER_ACTUAL,
  ACTUAL_OVER_365,
  ACTUAL_OVER_360,
  THIRTY_OVER_360
};
